import { PricesApiFactory } from '@mynt/backoffice-api-spec/billables'
import Axios from 'api/axios'
import config from 'config'
import type { CreatePriceRequest } from './api'
import { mapCreatePriceRequestToPriceRequestDto, mapTemplateAssignedPriceToHasAnchoredToSignupPrice } from './mappers'

const pricesApi = PricesApiFactory(undefined, config.boBaseUrl, Axios)

export const createBillableTemplatePrice = (billableId: string, templateId: string, price: CreatePriceRequest) =>
  pricesApi.createBillableItemPriceOnATemplate(billableId, templateId, mapCreatePriceRequestToPriceRequestDto(price))

export const hasTemplateAnchoredToSignupPrice = (templateId: string) => {
  return pricesApi
    .getAllBillableItemPricesOnATemplate(templateId)
    .then(({ data }) => data.some(mapTemplateAssignedPriceToHasAnchoredToSignupPrice))
}
